module.exports = __webpack_public_path__ + "img/Honigloeffel-v1-860.11d34d85.png";